const rootState = state => (!!state && state.variantFilterEditor) || {};


export default rootState;
